// extracted by mini-css-extract-plugin
export default {"pricing":"styles_pricing__Peqe-","spin":"styles_spin__gan0Q"};